import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from 'i18next-browser-languagedetector';
import { title } from "process";


i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        debug: true,
        fallbackLng: 'es',
        interpolation: {
            escapeValue: false,
        },
        resources: {
            es: {
                translation: {
                    branding: {
                        name: 'BitMasters',
                        slogan: 'Construyendo el futuro de las soluciones empresariales a través de aplicaciones y plataformas web innovadoras.',
                    },
                    homePage: {
                        lastMails: 'Últimos Mails',
                        balance: 'Ingresos',
                        users: 'Usuarios',
                        usersDesc: 'Total de usuarios activos actualmente',
                        balanceDesc: 'Ingresos totales recibidos en los últimos 30 días',
                        mails: {
                            desc: {
                                start: 'Se muestran',
                                end: 'mails de un total de',
                                totalMails: 'mails registrados.',
                                viewAll: 'Ver todos',
                            },
                        }
                    },
                    cummon: {
                        learnMore: 'Conocer Más',
                        copyright: '2025 BitMasters. Todos los derechos reservados.',
                    },
                    navigation: {
                        logout: 'Cerrar sesión',
                        dashboard: 'Panel de control',
                        users: 'Usuarios',
                        balance: 'Ingresos',
                        mails: 'Mails',
                        solutions: 'Soluciones',
                        web: 'Web',
                        balancePage: 'Ingresos y gestión de pagos',
                    },
                    footer: {
                        quickLinks: {
                            title: 'Enlaces rápidos',
                            links: {
                                home: 'Inicio',
                                help: 'Cntro de ayuda',
                            }
                        },
                        products: {
                            title: 'Productos',
                            links: {
                                mybillify: 'MyBillify',
                            }
                        },
                    },
                    notFoundPage: {
                        title: 'Página no encontrada',
                        subtitle: 'La página que estás buscando no existe o puede haber sido movida.',
                        buttons: {
                            primary: 'Vuelve al inicio',
                            secondary: 'Centro de ayuda',
                        }
                    },
                    login: {
                        title: 'Bienvenido de nuevo',
                        subtitle: 'Por favor, introduzca sus datos para iniciar sesión',
                        email: 'Email',
                        password: 'Contraseña',
                        forgotPassword: '¿Olvidaste la contraseña?',
                        signIn: 'Iniciar sesión',
                        enterMail: 'Introduzca su correo electrónico',
                        enterPassword: 'Introduzca su contraseña',
                    },
                    mails: {
                        noMails: 'No hay mails registrados',
                        noMail: 'No se ha encontrado el mail con id ',
                        table: {
                            mail: 'Mail',
                            date: 'Fecha',
                            time: 'Hora',
                            id: 'ID',
                            state: 'Estado',
                        },
                        locals: {
                            title: 'Mails locales',
                            noFileSelected: 'No se ha seleccionado ningún archivo',
                            open: 'Abrir',
                            create: 'Crear',
                            errors: {
                                emptyFolder: 'La carpeta no contiene archivos',
                                noMailsFilde: 'La carpeta no contiene el archivo necesario: Mails.json',
                                notEmptyFolder: 'La carpeta ya contiene archivos'
                            }
                        },
                        details: {
                            started: 'Empezado',
                            finished: 'Finalizado',
                            for: 'Para',
                            attemps: 'Intentos',
                            error: 'Error',
                            response: 'Respuesta del servidor: ',
                            accepted: 'Aceptados',
                            pending: 'Pendientes',
                            rejected: 'Rechazados',
                            template: {
                                title: 'Plantilla',
                                name: 'Nombre',
                                notFound: 'No se ha encontrado la plantilla con id ',
                            },
                            message: {
                                title: 'Mensaje',
                                subject: 'Asumpto',
                                text: 'Texto',
                                html: 'HTML',
                            },
                            completeMessage: {
                                title: 'Mensaje completo',
                                subject: 'Asumpto',
                                text: 'Texto',
                            }
                        }
                    },
                    balance: {
                        filter: {
                            amount: {
                                title: 'Importe',
                                min: 'Más grande o igual',
                                max: 'Más pequeño o igual',
                                error: 'El importe debe ser un número válido:\n - Un número entero o decimal con un máximo de 2 decimales\n - Un número igual o mayor a 0.01',
                            },
                            date: {
                                title: 'Fecha',
                                min: 'Posterior a',
                                max: 'Anterior a',
                            },
                            state: {
                                title: 'Estado',
                                canceled: 'Cancelado',
                                processing: 'En proceso',
                                requires_action: 'Requiere acción',
                                requires_capture: 'Requiere captura',
                                requires_confirmation: 'Requiere confirmación',
                                requires_payment_method: 'Requiere método de pago',
                                succeeded: 'Completado',
                            },
                            search: 'Buscar',
                            noResults: 'No hay resultados',
                        },
                        tables: {
                            overviwe: {
                                amount: 'Importe',
                                method: 'Método de pago',
                                description: 'Descripción',
                                customer: 'Cliente',
                                date: 'Fecha',
                            },
                            loadMore: 'Cargar más',
                        },
                    },
                    customers: {
                        noMethod: 'Sin metodo de pago',
                        noCustomer: 'Sin cliente',
                    },
                    solutions: {
                        filter: {
                            category: 'Categoría',
                            platform: 'Plataforma',
                            search: 'Buscar',
                            noResults: 'No hay resultados',
                        },
                        categories: {
                            billingInvoicing: 'Facturación y cobro',
                            clientManagement: 'Gestión de clientes',
                            productsManagement: 'Gestión de productos',
                        },
                        notFound: {
                            title: 'No se ha encontrado la solució',
                            subtitle: 'La solución que buscas no existe o puede haber sido movida.',
                            options: 'A lo mejor quieres',
                            products: 'verlos todos',
                            contact: 'contactarnos',
                            button: 'Volver al inicio',
                        },
                        page: {
                            learnMore: 'Saber más',
                            features: 'Funcionalidades destacadas',
                            screenshot: 'Capturas de pantalla de la aplicación',
                            mostPopular: 'Más Popular',
                            ourUsers: 'Lo que dicen nuestros usuarios',
                            feature: {
                                new: 'Añadir nueva funcionalidad',
                                newId: 'ID de la funcionalidad',
                                icon: 'Seleccionar un icono',
                                id: 'ID de la funcionalidad',
                                noId: 'Sin ID',
                                addLarge: 'Añadir bloque de texto',
                            },
                            images: {
                                add: 'Añadir una imagen',
                            },
                            pricing: {
                                title: 'Precios',
                                add: 'Añadir un precio',
                                addSection: 'Añadir una sección de precios',
                                actions: {
                                    duplicateSection: 'Duplicar sección',
                                    deleteSection: 'Eliminar sección',
                                    duplicatePrice: 'Duplicar precio',
                                    deletePrice: 'Eliminar precio',
                                    addFeature: 'Añadir característica',
                                    deleteSecondary: 'Eliminar precio secundario',
                                    addSecondary: 'Añadir precio secundario',
                                }
                            },
                            warning: {
                                title: 'Avíso',
                                message: 'Aún estás editando otra propiedad. Para poder continuar primero tienes que aceptar o descartar los cambios que estes realizando.'
                            },
                            settings: {
                                title: 'Configuración',
                                id: 'Id',
                                categories: 'Categorias',
                            }
                        }
                    },
                    actions: {
                        edit: 'Editar',
                        add: 'Añadir',
                        delete: 'Eliminar imagen',
                        change: 'Cambiar imagen',
                        deleteNormal: 'Eliminar',
                        moveUp: 'Mover arriba',
                        moveDown: 'Mover abajo',
                        moveRight: 'Mover a la derecha',
                        moveLeft: 'Mover a la izquierda',
                        addUser: 'Añadir testimonio',
                    },
                    widget: {
                        languageSwitcher: 'Idioma',
                        selection: {
                            options: 'Opciones',
                            selected: 'Seleccionadas',
                        }
                    }
                }
            },
            ca: {
                translation: {
                    branding: {
                        name: 'BitMasters',
                        slogan: "Construint el futur de les solucions empresarials a través d'aplicacions innovadores i plataformes web.",
                    },
                    homePage: {
                        lastMails: 'Últims Mails',
                        balance: 'Ingressos',
                        users: 'Usuaris',
                        usersDesc: 'Total d\'usuaris actius actualment',
                        balanceDesc: 'Ingressos totals rebuts en els darrers 30 dies',
                        mails: {
                            desc: {
                                start: 'Es mostren',
                                end: 'mails d\'un total de',
                                totalMails: 'mails registrats.',
                                viewAll: 'Veure\'ls tots',
                            },
                        }
                    },
                    cummon: {
                        learnMore: 'Saber-ne Més',
                        copyright: '2025 BitMasters. Tots els drets reservats.',
                    },
                    navigation: {
                        logout: 'Tancar sessió',
                        dashboard: 'Panell de control',
                        users: 'Usuaris',
                        balance: 'Ingressos',
                        mails: 'Mails',
                        solutions: 'Solucions',
                        web: 'Web',
                        balancePage: 'Ingressos i gestió de pagaments',
                    },
                    footer: {
                        quickLinks: {
                            title: 'Enllaços ràpids',
                            links: {
                                home: 'Inici',
                                help: 'Centre d\'ajuda',
                            }
                        },
                        products: {
                            title: 'Productes',
                            links: {
                                mybillify: 'MyBillify',
                            }
                        },
                    },
                    notFoundPage: {
                        title: 'Pàgina no trobada',
                        subtitle: 'La pàgina que busques no existeix o potser s\'ha mogut.',
                        buttons: {
                            primary: 'Torna a l\'inici',
                            secondary: 'Centro de ayuda',
                        }
                    },
                    login: {
                        title: 'Benvingut de nou',
                        subtitle: 'Si us plau, introdueix les teves dades per iniciar la sessió',
                        email: 'Email',
                        password: 'Contrasenya',
                        forgotPassword: 'Has oblidat la contrasenya?',
                        signIn: 'Inicia la sessió',
                        enterMail: 'Introdueix el teu correu electrònic',
                        enterPassword: 'Introdueix la teva contrasenya',
                    },
                    mails: {
                        noMails: 'No hi ha mails registrats',
                        noMail: 'No s\'ha trobat el mail amb id ',
                        table: {
                            mail: 'Mail',
                            date: 'Data',
                            time: 'Hora',
                            id: 'ID',
                            state: 'Estat',
                        },
                        locals: {
                            title: 'Mails locals',
                            noFileSelected: 'No s\'ha sel·leccionat cap arxiu',
                            open: 'Obrir',
                            create: 'Crear',
                            errors: {
                                emptyFolder: 'La carpeta no conté arxius',
                                noMailsFilde: 'La carpeta no conté l\'arxiu necessari: Mails.json',
                                notEmptyFolder: 'La carpeta ja conté arxius'
                            }
                        },
                        details: {
                            started: 'Començat',
                            finished: 'Finalitzat',
                            for: 'Per',
                            attemps: 'Intents',
                            error: 'Error',
                            response: 'Resposta del servidor: ',
                            accepted: 'Aceptats',
                            pending: 'Pendents',
                            rejected: 'Rebutjats',
                            template: {
                                title: 'Plantilla',
                                name: 'Nom',
                                notFound: 'No s\'ha trobat la plantilla amb id ',
                            },
                            message: {
                                title: 'Missatge',
                                subject: 'Asumpte',
                                text: 'Text',
                                html: 'HTML',
                            },
                            completeMessage: {
                                title: 'Missatge complet',
                                subject: 'Asumpte',
                                text: 'Text',
                            }
                        }
                    },
                    balance: {
                        filter: {
                            amount: {
                                title: 'Import',
                                min: 'Més gran o igual',
                                max: 'Més petit o igual',
                                error: 'L\'import ha de ser un número vàlid\n - Un número enter o decimal amb un màxim de 2 decimals\n - Un número igual o més gran a 0.01',
                            },
                            date: {
                                title: 'Data',
                                min: 'Posterior a',
                                max: 'Anterior a',
                            },
                            state: {
                                title: 'Estat',
                                canceled: 'Cancel·lat',
                                processing: 'En processament',
                                requires_action: 'Requereix acció',
                                requires_capture: 'Requereix captura',
                                requires_confirmation: 'Requereix confirmació',
                                requires_payment_method: 'Requereix mètode de pagament',
                                succeeded: 'Completat',
                            },
                            search: 'Cercar',
                            noResults: 'No hi ha resultats',
                        },
                        tables: {
                            overviwe: {
                                amount: 'Import',
                                method: 'Mètode de pagament',
                                description: 'Descripció',
                                customer: 'Client',
                                date: 'Data',
                            },
                            loadMore: 'Carregar més',
                        }
                    },
                    customers: {
                        noMethod: 'Sense mètode de pagament',
                        noCustomer: 'Sense client',
                    },
                    solutions: {
                        filter: {
                            category: 'Categoria',
                            platform: 'Plataforma',
                            search: 'Cercar',
                            noResults: 'No hi ha resultats',
                        },
                        categories: {
                            billingInvoicing: 'Facturació i cobrament',
                            clientManagement: 'Gestió de clients',
                            productsManagement: 'Gestió de productes',
                        },
                        notFound: {
                            title: 'No s\'ha trobat la solució',
                            subtitle: 'La solució que busques no existeix o potser s\'ha mogut.',
                            options: 'Potser vols',
                            products: 'veure\'ls tots',
                            contact: 'contactar-nos',
                            button: 'Torna a l\'inici',
                        },
                        page: {
                            learnMore: 'Saber-ne més',
                            features: 'Funcionalitats destacades',
                            screenshot: 'Captures de pantalla de l\'aplicació',
                            mostPopular: 'Més Popular',
                            ourUsers: 'El que diuen els nostres usuaris',
                            feature: {
                                new: 'Afegir nova funcionalitat',
                                newId: 'ID de la funcionalitat',
                                icon: 'Seleccionar un icona',
                                id: 'ID de la funcionalitat',
                                noId: 'Sense ID',
                                addLarge: 'Afegir bloc de text',
                            },
                            images: {
                                add: 'Afegir una imatge',
                            },
                            pricing: {
                                title: 'Preus',
                                add: 'Afegir un preu',
                                addSection: 'Afegir una secció de preus',
                                actions: {
                                    duplicateSection: 'Duplicar secció',
                                    deleteSection: 'Eliminar secció',
                                    duplicatePrice: 'Duplicar preu',
                                    deletePrice: 'Eliminar preu',
                                    addFeature: 'Afegir característica',
                                    deleteSecondary: 'Eliminar preu secundari',
                                    addSecondary: 'Afegir preu secundari',
                                }
                            },
                            warning: {
                                title: 'Avís',
                                message: 'Encara estàs editant una altra propietat. Per poder continuar primer has d\'acceptar o descartar els canvis que estiguis realitzant.'
                            },
                            settings: {
                                title: 'Configuració',
                                id: 'Id',
                                categories: 'Categories',
                            }
                        }
                    },
                    actions: {
                        edit: 'Editar',
                        add: 'Afegir',
                        delete: 'Eliminar imatge',
                        change: 'Canviar imatge',
                        deleteNormal: 'Eliminar',
                        moveUp: 'Moure amunt',
                        moveDown: 'Moure avall',
                        moveRight: 'Moure a la dreta',
                        moveLeft: 'Moure a l\'esquerra',
                        addUser: 'Afegir testimoni',
                    },
                    widget: {
                        languageSwitcher: 'Idioma',
                        selection: {
                            options: 'Opcions',
                            selected: 'Seleccionades',
                        }
                    }
                }
            }
        }
    });

export default i18n;